import axios from 'axios'
import { Toast } from 'vant'

// axios.defaults.withCredentials = true
/**
 * 自定义实例默认值
 */
var instance = axios.create({
  timeout: 30000 // 请求超时
})

// let toast

instance.interceptors.request.use(
  config => {
    // toast = Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   forbidClick: true, // 禁用背景点击
    //   loadingType: 'spinner',
    //   message: '加载中'
    // })
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  function (response) {
    // toast.clear()
    if (response.status.toString() === '200') {
      if (!response.data.status.succeed) {
        Toast.fail(response.data.status.error_desc)
      }
    }
    return response
  },
  function (error) {
    Toast.fail(error.toString())
    return Promise.reject(error)
  }
)

export default instance
